"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildRegistrationWaitingListApplicationService = void 0;
const operators_1 = require("rxjs/operators");
class ChildRegistrationWaitingListApplicationService {
    constructor(repo) {
        this.repo = repo;
    }
    numChildrenOnWaitingList(tenantId) {
        return this.repo.getAll(tenantId).pipe(operators_1.map((list) => list.length));
    }
    isOnRegistrationWaitingList(tenantId, childId) {
        return this.repo.getById(tenantId, childId).pipe(operators_1.map((c) => c !== null));
    }
    childrenOnWaitingList(tenantId) {
        return this.repo.getAll(tenantId);
    }
    // TODO should be a command
    removeChildFromRegistrationWaitingList(tenantId, childOnWaitingListId) {
        return this.repo.delete(tenantId, childOnWaitingListId);
    }
    // TODO should be a command
    addChildToWaitingList(child) {
        return this.repo.add(child);
    }
    childrenOnRegistrationWaitingListForParent(tenantId, parentUid) {
        return this.repo
            .getAll(tenantId)
            .pipe(operators_1.map((list) => list.filter((child) => child.createdByParentUid === parentUid)));
    }
}
exports.ChildRegistrationWaitingListApplicationService = ChildRegistrationWaitingListApplicationService;
//# sourceMappingURL=child-registration-waiting-list.application-service.js.map